let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("j4CTh")).then(() => parcelRequire('4NZXC'));